angular.module('impactx.user').controller('UserPanelCtrl', ['$mdDialog', UserPanelCtrl]);

function UserPanelCtrl($mdDialog) {
    var self = this;
    this.openInfoDialog = function(ev, userData) {
        $mdDialog.hide();

        $mdDialog.show({
            controller: 'SimpleDialogCtrl',
            controllerAs: 'simpleDialogCtrl',
            templateUrl: 'shared/user/templates/usercontact.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false,
            locals: {
                userData: userData,
                buttonFunction: self.buttonFunction,
                buttonTranslation: self.buttonTranslation
            }
        });
    };
}